import React, { useState } from "react";
import {
  Check,
  X,
  Trash2,
  Search,
  Edit,
} from "lucide-react"; // Install: npm i lucide-react

const ProductReviews = () => {
  const [search, setSearch] = useState("");

  const reviews = [
    {
      id: 1,
      product: "$50 Physical Gift Card",
      customer: "admin@yourStore.com",
      title: "Some sample review",
      text: "This sample review is for the $50 Physical Gift Card. I've been waiting for this product to be available. It is priced just right.",
      rating: 5,
      approved: true,
      createdOn: "02/11/2025 10:34:46 PM",
    },
    {
      id: 2,
      product: "Vintage Style Engagement Ring",
      customer: "admin@yourStore.com",
      title: "Some sample review",
      text: "This sample review is for the Vintage Style Engagement Ring. I've been waiting for this product to be available. It is priced just right.",
      rating: 5,
      approved: true,
      createdOn: "02/11/2025 10:34:46 PM",
    },
    {
      id: 3,
      product: "$25 Virtual Gift Card",
      customer: "admin@yourStore.com",
      title: "Some sample review",
      text: "This sample review is for the $25 Virtual Gift Card. I've been waiting for this product to be available. It is priced just right.",
      rating: 5,
      approved: true,
      createdOn: "02/11/2025 10:34:46 PM",
    },
    {
      id: 4,
      product: "Flower Girl Bracelet",
      customer: "admin@yourStore.com",
      title: "Some sample review",
      text: "This sample review is for the Flower Girl Bracelet. I've been waiting for this product to be available. It is priced just right.",
      rating: 4,
      approved: true,
      createdOn: "02/11/2025 10:34:46 PM",
    },
  ];

  const filtered = reviews.filter(
    (r) =>
      r.product.toLowerCase().includes(search.toLowerCase()) ||
      r.customer.toLowerCase().includes(search.toLowerCase()) ||
      r.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      {/* Header */}
      <h1 className="text-2xl md:text-3xl font-semibold mb-4">
        Product reviews
      </h1>

      {/* Top Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 mb-4">
        <button className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md shadow">
          <Check size={18} /> Approve selected
        </button>
        <button className="flex items-center justify-center gap-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md shadow">
          <X size={18} /> Disapprove selected
        </button>
        <button className="flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md shadow">
          <Trash2 size={18} /> Delete selected
        </button>
      </div>

      {/* Search Bar */}
      <div className="bg-white rounded-lg shadow p-4 mb-6">
        <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
          <Search className="text-gray-500 mx-3" size={18} />
          <input
            type="text"
            placeholder="Search"
            className="w-full py-2 px-2 outline-none"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-3 border-b">
                <input type="checkbox" />
              </th>
              <th className="p-3 border-b">Product</th>
              <th className="p-3 border-b">Customer</th>
              <th className="p-3 border-b">Title</th>
              <th className="p-3 border-b">Review text</th>
              <th className="p-3 border-b">Rating</th>
              <th className="p-3 border-b">Is approved</th>
              <th className="p-3 border-b">Created on</th>
              <th className="p-3 border-b">Edit</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr
                key={r.id}
                className="border-b hover:bg-gray-50 transition-colors"
              >
                <td className="p-3">
                  <input type="checkbox" />
                </td>
                <td className="p-3 text-blue-600 hover:underline whitespace-nowrap">
                  {r.product}
                </td>
                <td className="p-3 whitespace-nowrap">{r.customer}</td>
                <td className="p-3 whitespace-nowrap">{r.title}</td>
                <td className="p-3">{r.text}</td>
                <td className="p-3 text-center">{r.rating}</td>
                <td className="p-3 text-center">
                  {r.approved && (
                    <Check className="text-green-600 inline" size={18} />
                  )}
                </td>
                <td className="p-3 whitespace-nowrap">{r.createdOn}</td>
                <td className="p-3">
                  <button className="flex items-center gap-1 text-gray-700 hover:text-blue-600">
                    <Edit size={16} /> Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Mobile Card View */}
        <div className="block md:hidden p-3">
          {filtered.map((r) => (
            <div
              key={r.id}
              className="border rounded-lg mb-3 p-3 bg-gray-50 shadow-sm"
            >
              <div className="flex justify-between items-center mb-1">
                <h2 className="text-blue-600 font-semibold">{r.product}</h2>
                <span className="text-sm text-gray-600">{r.rating}⭐</span>
              </div>
              <p className="text-sm text-gray-700 mb-1">{r.text}</p>
              <p className="text-xs text-gray-500">{r.customer}</p>
              <div className="flex justify-between items-center mt-2">
                <span className="text-xs text-gray-500">{r.createdOn}</span>
                <button className="text-blue-600 flex items-center gap-1 text-xs">
                  <Edit size={14} /> Edit
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <p className="text-sm text-gray-500 mt-4">
        Learn more about{" "}
        <a href="#" className="text-blue-600 underline">
          product reviews
        </a>
      </p>
    </div>
  );
};

export default ProductReviews;
